export default __webpack_public_path__ + "static/media/cardBackBtn.cd74c553.svg";